<template>
  <div class="my_container">
    <h1 class="title">User Profile</h1>
    <div class="user_page">
      <div>
        <button @click="refreshAccessToken" class="refresh-button">Refresh Access Token</button>
      </div>
      <div class="card">
        <h1>User Details:</h1>
        <div class="detail">
          <h2>Name: {{ name }}</h2>
        </div>
        <div class="detail">
          <h2>Last Name: {{ last_name }}</h2>
        </div>
        <div class="detail">
          <h2>email: {{ email }}</h2>
        </div>
        <div class="detail">
          <h2>role: {{ role }}</h2>
        </div>
         <div class="detail">
          <h2>user Id: {{ uid }}</h2>
        </div>
        <div class="actions">
          <button @click="showDeleteDialog = true" class="delete-button">Delete Account</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirmation Dialog -->
  <div v-if="showDeleteDialog" class="dialog-backdrop">
    <div class="dialog">
      <p>Are you sure you want to delete your account? After deletion you will not be able to use any Carenuity service.</p>
      <div class="dialog-actions">
        <button @click="deleteAccount" class="confirm-button">Yes</button>
        <button @click="showDeleteDialog = false" class="cancel-button">No</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { useStore } from '@/composables/core/useStore';
import { useRouter } from 'vue-router';
import { useNotification } from '@/composables/ui/useNotification';

export default defineComponent({
  name: 'UserPage',
  setup() {
    const store = useStore();
    const router = useRouter();
    const notification = useNotification();

    const showDeleteDialog = ref(false);

    const name = computed(() => store.getters['auth/userName'] as string || '');
    const last_name = computed(() => store.getters['auth/userLastName'] as string || '');
    const email = computed(() => store.getters['auth/userEmail'] as string || '');
    const role = computed(() => store.getters['auth/userRole'] as string || '');
    const uid = computed(() => store.getters['auth/userId'] as string || '');

    const deleteAccount = async (): Promise<void> => {
      try {
        await store.dispatch('auth/deleteAccount');
        notification.success('Account Deleted', 'Your account has been successfully deleted.');
        router.replace('/');
      } catch (error) {
        console.error(error);
        notification.error('Error', 'An error occurred while deleting your account. Please try again.');
      } finally {
        showDeleteDialog.value = false;
      }
    };

    const refreshAccessToken = async (): Promise<void> => {
      try {
        await store.dispatch('refreshAccessToken');
        notification.success('Token Refreshed', 'Access token refreshed successfully.');
      } catch (error) {
        console.error(error);
        notification.error('Error', 'An error occurred while refreshing the access token. Please try again.');
      }
    };

    return {
      name,
      last_name,
      email,
      role,
      uid,
      showDeleteDialog,
      deleteAccount,
      refreshAccessToken,
    };
  },
});
</script>

<style scoped>
div {
  background: transparent;
}

.user_page .card {
  width: 800px;
}

.user_page .card h1 {
  text-align: center;
  background-color: transparent;
}

.detail {
  display: grid;
  grid-template-columns: 4fr 1fr;
  text-align: left;
  background: transparent;
  padding-bottom: 0.5rem;
}

/* Dialog Styles */
.dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  width: 400px;
}

.dialog-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 1rem;
}

.confirm-button {
  background-color: red;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button {
  background-color: gray;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.delete-button {
  background-color: red;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 1rem;
}
</style>
